import _extends from "../../../@babel/runtime/helpers/esm/extends.es.js";
import "react";
import PropTypes from "../../../prop-types/index.es.js";
import { GlobalStyles as GlobalStyles$1 } from "@mui/system";
import defaultTheme from "../styles/defaultTheme.es.js";
import THEME_ID from "../styles/identifier.es.js";
import { j as jsxRuntimeExports } from "../../../react/jsx-runtime.es.js";
function GlobalStyles(props) {
  return /* @__PURE__ */ jsxRuntimeExports.jsx(GlobalStyles$1, _extends({}, props, {
    defaultTheme,
    themeId: THEME_ID
  }));
}
process.env.NODE_ENV !== "production" ? GlobalStyles.propTypes = {
  // ┌────────────────────────────── Warning ──────────────────────────────┐
  // │ These PropTypes are generated from the TypeScript type definitions. │
  // │    To update them, edit the d.ts file and run `pnpm proptypes`.     │
  // └─────────────────────────────────────────────────────────────────────┘
  /**
   * The styles you want to apply globally.
   */
  styles: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.number, PropTypes.object, PropTypes.string, PropTypes.bool])
} : void 0;
export {
  GlobalStyles as default
};
//# sourceMappingURL=GlobalStyles.es.js.map
